function normalizeApiOrigin(raw: string): string {
  let t = raw.trim().replace(/\/+$/, "");
  if (t === "") return "";
  t = t.replace(/\/api\/v1$/i, "").replace(/\/api$/i, "").replace(/\/+$/, "");
  return t;
}

/**
 * When unset, returns `""` so requests use same-origin `/api` and the Vite dev proxy applies (no CORS).
 */
export function getDispensaryApiBaseUrl(): string {
  const v = import.meta.env.VITE_API_BASE_URL;
  if (typeof v === "string" && v.trim().length > 0) {
    return normalizeApiOrigin(v);
  }
  return "";
}
